import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS
} from '../../../themes'
import { colorThemeSelector } from '../../../helpers'
export const StyleModal = styled.div`
  color: ${COLOR.BLACK_1};
  background: #000000AA;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${Z_INDEXS.LV_9};

  .content-Modal{
    border-radius: 8px;
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: #FFF;
    height: 300px;
    top: 20%;
    width: ${500}px;
    font-size: ${FONT_SIZE.SM};
    padding-top: 100px;
    padding-left: 100px;
    padding-right: 100px;
    text-align: center;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
  }

  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: 100px;
      padding-right: 100px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: 100px;
      padding-right: 100px;
    }
  }

  .head-modal, .head-modal-error{
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.XXL};
    letter-spacing: 1px;
    margin-bottom: 40px
  }

  .text-modal, .text-modal-error{
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.XS};
    margin-bottom: 25px;
  }

  .text-modal-error{
    margin-top: 20px;
    color: ${COLOR.RED_2};
  }

  .description-confirm, .description-confirm-error{
    word-break: break-all;
    margin-top: 5%;
    border-bottom: 1px solid ${COLOR.GRAY_1};
    width: 100%;
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 6px;
    // margin-left: 30px;
    // margin-right: 30px;
  }

  // .description-error{
  //   margin-top: 20px;
  // }

  .modal-btn-confirm, .modal-btn-back{
    width: 196px;
    margin: auto;
    margin-top: 26px;
    font-size: ${FONT_SIZE.XS};
    font-family: NunitoBold;
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    float: none;
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT ?? COLOR.BLACK_1};
  }

  .modal-btn-back{
    background: ${COLOR.BLACK_1};
    color: ${COLOR.WHITE};
  }

  @media screen and (max-width:500px){
    .content-Modal {
      width: 260px;
    }
  }

`
